module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_1.8cc43b73.png";